var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCurveShape = function SvgCurveShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 69,
    viewBox: "0 0 375 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380 0s-98.188 6.965-195.461 4.088C87.266 1.211-11 14.686-11 14.686V61a8 8 0 0 0 8 8h375a8 8 0 0 0 8-8V0Z",
    fill: "#F7F3F0"
  })));
};
export default SvgCurveShape;